// Translation strings for Finnish (fi).
//
// Split out of the former single translations.js so the three languages can be
// edited without colliding. t() has NO fallback - a key missing here renders as
// the raw key name, so every language must define every key.
// `npm run check:translations` asserts that.

const fi = {
  // Common
  cancel: 'Peruuta',
  save: 'Tallenna',
  delete: 'Poista',
  edit: 'Muokkaa',
  add: 'Lisää',
  close: 'Sulje',
  search: 'Hae',
  loading: 'Ladataan...',
  error: 'Virhe',
  success: 'Onnistui',

  // Navigation
  login: 'Kirjaudu',
  logout: 'Kirjaudu ulos',
  adminPanel: 'Hallintapaneeli',
  publicView: 'Julkinen näkymä',
  settings: 'Asetukset',
  account: 'Tili',
  menu: 'Valikko',

  // User Management
  username: 'Käyttäjänimi',
  password: 'Salasana',
  email: 'Sähköposti',
  role: 'Rooli',
  superAdmin: 'Pääkäyttäjä',
  countryAdmin: 'Maan ylläpitäjä',
  editor: 'Muokkaaja',
  manageUsers: 'Hallinnoi käyttäjiä',
  changePassword: 'Vaihda salasana',
  newPassword: 'Uusi salasana',
  confirmPassword: 'Vahvista salasana',
  currentPassword: 'Nykyinen salasana',
  allFieldsRequired: 'Kaikki kentät ovat pakollisia',
  passwordsDoNotMatch: 'Uudet salasanat eivät täsmää',
  passwordTooShort: 'Uuden salasanan on oltava vähintään 6 merkkiä',
  passwordChangedSuccessfully: 'Salasana vaihdettu onnistuneesti!',
  failedToChangePassword: 'Salasanan vaihto epäonnistui',
  connectionError: 'Yhteysvirhe',
  saveFailed: 'Tallennus epäonnistui',
  userManagement: 'Käyttäjien hallinta',
  backToAdmin: 'Takaisin hallintaan',
  addNewUser: 'Lisää uusi käyttäjä',
  emailOptional: 'Sähköposti (valinnainen)',
  rolePermissions: 'Roolien oikeudet:',
  editorRole: 'Muokkaaja:',
  editorDescription: 'Sarjat, kilpailut, kuljettajat ja tulokset omassa maassa (ei oikeuksia käyttäjiin)',
  superAdminRole: 'Pääkäyttäjä:',
  superAdminDescription: 'Kaikki maat, ja ainoa rooli joka voi nimittää uuden pääkäyttäjän',
  countryAdminRole: 'Maan ylläpitäjä:',
  countryAdminDescription: 'Kaikki mitä pääkäyttäjäkin, mutta vain omassa maassa',
  countryAdminScopeHint: 'Hallinnoit yhtä maata. Muiden maiden sarjat, kilpailut ja käyttäjät kuuluvat niiden omille ylläpitäjille.',
  managedBySuperAdmin: 'Pääkäyttäjän hallinnassa',
  addUser: 'Lisää käyttäjä',
  existingUsers: 'Olemassa olevat käyttäjät',
  created: 'Luotu:',
  lastLogin: 'Viimeisin kirjautuminen:',
  usernameAndPasswordRequired: 'Käyttäjänimi ja salasana ovat pakollisia',
  userCreatedSuccessfully: 'Käyttäjä luotu onnistuneesti',
  failedToCreateUser: 'Käyttäjän luonti epäonnistui',
  deleteThisUser: 'Poista tämä käyttäjä?',
  failedToDeleteUser: 'Käyttäjän poisto epäonnistui',
  editUser: 'Muokkaa käyttäjää',
  usernameRequired: 'Käyttäjänimi vaaditaan',
  userUpdatedSuccessfully: 'Käyttäjä päivitetty onnistuneesti',
  failedToUpdateUser: 'Käyttäjän päivitys epäonnistui',
  resetPassword: 'Nollaa salasana',
  resetPasswordFor: 'Nollaa salasana käyttäjälle',
  minimumSixCharacters: 'Vähintään 6 merkkiä',
  passwordResetSuccessfully: 'Salasana nollattu onnistuneesti',
  failedToResetPassword: 'Salasanan nollaus epäonnistui',

  // Series Management
  series: 'Sarja',
  seriesSettings: 'Sarjan asetukset',
  selectSeries: 'Valitse sarja',
  selectYear: 'Valitse vuosi',
  noSeriesForYear: 'Ei sarjoja vuodelle',
  createSeries: 'Luo uusi sarja',
  seriesName: 'Sarjan nimi',
  startYear: 'Aloitusvuosi',
  endYear: 'Lopetusvuosi',
  yearHint: 'Lopetusvuosi on valinnainen. Käytä sitä talvisarjoille (esim. 2024-2025)',
  racingSeries: 'Kilpailusarjat',
  newSeries: 'Uusi sarja',
  noSeriesYet: 'Ei vielä sarjoja. Luo ensimmäinen!',
  deleteSelectedSeries: 'Poista valittu sarja',
  deleteThisSeries: 'Poista tämä sarja ja kaikki sen tiedot?',
  editSeries: 'Muokkaa sarjaa',
  seriesNameRequired: 'Sarjan nimi vaaditaan',
  seriesClass: 'Luokka',
  seriesClasses: 'Luokat',
  seriesClassHelp: 'Sarjassa voi olla useita luokkia. Jokaisella on omat kuljettajansa, kilpailunsa ja pistetilanteensa.',
  addSeriesClass: 'Lisää luokka',
  seriesClassName: 'Luokan nimi',
  seriesClassNameRequired: 'Luokan nimi vaaditaan',
  deleteSeriesClassConfirm: 'Poista tämä luokka sekä sen kilpailut ja tulokset?',
  seriesClassLastCannotDelete: 'Sarjassa on oltava vähintään yksi luokka.',
  seriesClassHasResults: 'Luokkaan on kirjattu tuloksia. Poista ne ensin.',
  seriesClassNameTaken: 'Samanniminen luokka on jo tässä sarjassa',
  classSettings: 'Luokan asetukset',
  inheritFromSeries: 'Käytä sarjan asetusta',
  inheritedValue: 'Sarjan asetus',
  addExistingDriver: 'Lisää kuljettaja tästä sarjasta',
  removeFromClass: 'Poista tästä luokasta',
  removeFromClassConfirm: 'Poistetaanko kuljettaja tästä luokasta? Muiden luokkien tulokset säilyvät.',
  deleteDriverEverywhere: 'Poista koko sarjasta',
  deleteDriverEverywhereConfirm: 'Poistetaanko kuljettaja sarjan kaikista luokista kaikkine tuloksineen?',
  carNumberTakenInClass: 'Kilpailunumero on jo toisen kuljettajan käytössä tässä luokassa',
  driverNotInClass: 'Kuljettaja ei aja tässä sarjassa',
  noDriversInThisClass: 'Luokassa ei ole kuljettajia',
  country: 'Maa',
  // Maavalitsimen ryhmät. Haetaan dynaamisesti nimellä continent + ryhmän nimi,
  // joten check-translations.js ei näe näitä - countryGroups.test.js varmistaa,
  // että kaikki kahdeksan löytyvät kaikilta kolmelta kieleltä.
  continentNordic: 'Pohjoismaat ja Baltia',
  continentEurope: 'Eurooppa',
  continentAfrica: 'Afrikka',
  continentAsia: 'Aasia',
  continentNorthAmerica: 'Pohjois-Amerikka',
  continentSouthAmerica: 'Etelä-Amerikka',
  continentOceania: 'Oseania',
  continentAntarctica: 'Etelämanner',
  countryRequired: 'Maa vaaditaan',
  create: 'Luo',
  update: 'Päivitä',
  totalRaces: 'Kilpailuja yhteensä',
  racesCounted: 'Lasketut kilpailut',
  qualificationMaster: 'TQ Mestari',
  calculateQualificationPoints: 'Laske karsintapisteet',
  juniorChampionship: 'Juniorimestaruus',
  seniorChampionship: 'Seniorimestaruus',
  ageLimit: 'Ikäraja',
  totalRacesDescription: 'Kuinka monta kilpailua sarjassa on yhteensä',
  racesCountedDescription: 'Kuinka monta parasta tulosta lasketaan mestaruuteen. 0 = kaikki lasketaan.',
  racesInSeries: 'kilpailua sarjassa',
  best: 'paras',
  countedLabel: 'lasketaan',
  qualificationPointsDescription: 'Top 5 karsinnan sijoittuneet saavat 5, 4, 3, 2, 1 bonuspistettä',
  qualificationMasterDescription: '🏆 Erillinen mestaruus vain karsintapisteistä',
  enable: 'Ota käyttöön',
  yearsAndUnder: 'vuotta ja alle',
  yearsOld: 'vuotta vanha',
  plusYearsOld: '+ vuotta vanha',
  driversAgeAndUnder: 'Kuljettajat {age} vuotta ja alle',
  driversPlusYearsOld: 'Kuljettajat {age}+ vuotta',
  tip: 'Vinkki:',
  changesAutoSaved: 'Muutokset tallennetaan automaattisesti. Tulokset päivittyvät välittömästi vastaamaan asetuksiasi.',
  exportChampionshipDataToExcel: 'Vie mestaruustiedot Exceliin',
  pleaseSelectAtLeastOneSeries: 'Valitse vähintään yksi sarja vietäväksi',
  exportFailed: 'Vienti epäonnistui',
  failedToExportChampionship: 'Mestaruustietojen vienti epäonnistui. Yritä uudelleen.',
  sessionExpired: 'Istunto on vanhentunut. Kirjaudu uudelleen sisään.',
  noSeriesAvailable: 'Ei saatavilla olevia sarjoja',

  // Driver Management
  drivers: 'Kuljettajat',
  driverName: 'Kuljettajan nimi',
  birthYear: 'Syntymävuosi',
  club: 'Seura',
  addDriver: 'Lisää kuljettaja',
  editDriver: 'Muokkaa kuljettajaa',
  newDriver: 'Uusi kuljettaja',
  carNumberOptional: 'Auton numero (valinnainen)',
  clubOptional: 'Seura (valinnainen)',
  birthYearOptional: 'Syntymävuosi (valinnainen)',
  noDriversYet: 'Ei vielä kuljettajia.',
  deleteThisDriver: 'Poista tämä kuljettaja?',
  failedToRemoveFromClass: 'Kuljettajan poistaminen luokasta epäonnistui',
  selectAll: 'Valitse kaikki',
  deselectAll: 'Poista valinnat',
  deleteSelected: 'Poista valitut',
  deleteSelectedDrivers: 'Poista {count} valittua kuljettajaa?',
  copyDrivers: 'Kopioi kuljettajat',
  copyFromOtherSeries: 'Kopioi toisesta sarjasta',
  copyDriversFromOtherSeries: 'Kopioi kuljettajat toisesta sarjasta',
  selectSeriesToCopyFrom: 'Valitse sarja, josta kopioidaan kuljettajat',
  noOtherSeriesAvailable: 'Ei muita sarjoja saatavilla',
  copyingFrom: 'Kopioidaan sarjasta',
  selectDriversToCopy: 'Valitse kopioitavat kuljettajat',
  noDriversInThisSeries: 'Tässä sarjassa ei ole kuljettajia',
  copySelected: 'Kopioi valitut',
  back: 'Takaisin',
  driversCopiedSuccessfully: '{count} kuljettajaa kopioitu onnistuneesti',
  failedToCopyDrivers: 'Kuljettajien kopiointi epäonnistui',

  // Race Management
  races: 'Kilpailut',
  raceName: 'Kilpailun nimi',
  raceDate: 'Päivämäärä',
  raceSequenceNumber: 'Kilpailun tunnus (esim. SM2, Round 1)',
  addRace: 'Lisää kilpailu',
  editRace: 'Muokkaa kilpailua',
  raceResults: 'Kilpailutulokset',
  addResults: 'Lisää tulokset',
  newRace: 'Uusi kilpailu',
  deleteThisRace: 'Poista tämä kilpailu?',
  pleaseSelectSeriesFirst: 'Valitse ensin sarja',
  errorCreatingRace: 'Virhe kilpailun luomisessa: ',
  editResults: 'Muokkaa tuloksia',
  importFromExcel: 'Tuo Excelistä',
  importFromMyRCM: 'Tuo MyRCM:stä',
  // LiveRC-tuonti. liverc*-virheavaimet annetaan t():lle nimellä
  // utils/liverc.js:n parseLiveRCUrl:sta, joten check-translations.js ei näe
  // niiden käyttöä - liverc.test.js varmistaa että ne kaikki löytyvät.
  importFromLiveRC: 'Tuo LiveRC:stä',
  howToImportFromLiveRC: 'Näin tuot tulokset LiveRC:stä:',
  livercStep1: 'Avaa kilpailu radan omalla LiveRC-sivulla, esimerkiksi gandsraceway.liverc.com',
  livercStep2: 'Kopioi kilpailusivun osoite ja liitä se alle',
  livercStep3: 'Valitse tämän kilpailun luokka, tarkista kuljettajien vastaavuudet ja tuo tulokset',
  livercUrlLabel: 'LiveRC-kilpailun osoite',
  livercUrlHint: 'Kilpailusivu tai sen Final Results -sivu. Kaikki kilpailun luokat luetaan siitä.',
  livercFetching: 'Luetaan LiveRC:tä...',
  livercPickClass: 'Luokka',
  livercPickClassPlaceholder: 'Valitse tämän kilpailun luokka',
  livercNoQualifying: 'Tässä kilpailussa ei ole aika-ajotuloksia, joten aika-ajopisteet jäävät tyhjiksi.',
  livercCreateNewDriver: 'Luo uusi kuljettaja',
  livercLabel: 'LiveRC:',
  livercEventLoaded: 'Kilpailusta löytyi {count} luokkaa',
  livercImported: 'Tuotiin {count} tulosta luokkaan {class}',
  livercFetchFailed: 'LiveRC:hen ei saatu yhteyttä',
  livercEventNotFound: 'Kilpailulla ei ole julkaistuja tuloksia',
  livercNoResultsTable: 'Sivulla ei ole tulostaulukkoa',
  livercUrlRequired: 'Liitä ensin LiveRC-kilpailun osoite',
  livercNotALiveRCUrl: 'Osoite ei ole LiveRC-osoite',
  livercNotAnEventUrl: 'Osoite on LiveRC-sivu mutta ei kilpailusivu. Käytä kilpailun tai Final Results -sivun osoitetta.',
  livercNoEventId: 'Osoitteesta puuttuu kilpailun tunnus',
  failedToCreateDriver: 'Kuljettajan luonti epäonnistui',
  resultsAdminOnly: 'Tulokset (vain admin)',
  deleteRace: 'Poista kilpailu',
  resetRaceResults: 'Tyhjennä kilpailun tulokset',
  resetRaceResultsConfirm: 'Haluatko varmasti tyhjentää kaikki tulokset tästä kilpailusta?',
  raceResultsReset: 'Kilpailun tulokset tyhjennetty onnistuneesti',
  failedToResetResults: 'Tulosten tyhjennys epäonnistui',
  editResultsFor: 'Muokkaa tuloksia:',
  driver: 'Kuljettaja',
  qualPos: 'Kars. sij.',
  qualPts: 'Kars. p.',
  saveResults: 'Tallenna tulokset',
  failedToSaveRankings: 'Tulosten tallennus epäonnistui',

  // Standings
  standings: 'Tulokset',
  championshipStandings: 'Mestaruustulokset',
  qualificationStandings: 'Karsintatulokset',
  juniorStandings: 'Juniorimestaruus',
  seniorStandings: 'Seniorimestaruus',
  position: 'Sij.',
  name: 'Nimi',
  totalPoints: 'Yht.',
  racesParticipated: 'Kilpailuja',
  bestResult: 'Paras tulos',
  qualificationMasterStandings: 'TQ Mestari Tulokset',
  allQualificationPoints: 'KAIKKI Karsintatulokset',
  pureQualificationChampionship: 'Puhdas karsintatulosmestaruus:',
  allQualificationPointsCounted: 'Kaikki karsintatulokset lasketaan (ei pudotuksia)',
  juniorChampionshipStandings: 'Juniorimestaruus Tulokset',
  seniorChampionshipStandings: 'Seniorimestaruus Tulokset',
  ageAndUnder: 'vuotta ja alle',
  agePlus: 'vuotta+',
  juniorDriversOnly: 'Vain juniorit:',
  seniorDriversOnly: 'Vain seniorit:',
  onlyDriversAgedIncluded: 'Vain kuljettajat, joiden ikä on',
  andUnderIncluded: 'ja alle, sisällytetty',
  andOverIncluded: 'ja yli, sisällytetty',
  noStandingsYet: 'Ei vielä tuloksia.',
  noQualificationDataYet: 'Ei vielä karsintatuloksia.',
  noJuniorDriversYet: 'Ei vielä juniorikuljettajia tuloksissa.',
  noSeniorDriversYet: 'Ei vielä seniorikuljettajia tuloksissa.',
  noRacesYet: 'Ei vielä kilpailuja.',
  noResultsYet: 'Ei vielä tuloksia',
  driversCount: 'kuljettajaa',
  born: 'Syntynyt:',
  dropped: 'pudotettu',
  raceShort: 'Kilp',
  qualShort: 'Kars',
  points: 'pistettä',
  total: 'Yhteensä',

  // Export & Import
  exportExcel: 'Vie Excel',
  exportChampionships: 'Vie mestaruudet Exceliin',
  selectSeriesToExport: 'Valitse vietävät sarjat:',
  selectAtLeastOne: 'Valitse vähintään yksi sarja',
  selected: 'valittu',
  export: 'Vie',
  exportLanguage: 'Viennin kieli',
  preview: 'Esikatselu',
  importing: 'Tuodaan...',
  chooseExcelFile: 'Valitse Excel-tiedosto',
  excelFileFormat: 'Excel-tiedoston muoto:',
  columnDriver: 'Sarake: Driver tai Name (kuljettajan nimi)',
  columnPosition: 'Sarake: Position tai Pos (kilpailusijoitus: 1-50)',
  columnQual: 'Sarake: Qual tai Q (valinnainen, karsintasijoitus: 1-5)',
  driversNotInSeriesCreated: 'Kuljettajia, jotka eivät ole sarjassasi, luodaan automaattisesti.',
  resultsReadyToImport: 'tulos(ta) valmis tuotavaksi',
  newDriversWillBeCreated: 'uusi kuljettaja(a) luodaan:',
  rowsSkipped: 'rivi(ä) ohitettiin:',
  andMore: 'ja {count} lisää',
  rememberToAddClubAndBirthYear: '💡 Tuonnin jälkeen: Muista lisätä seura- ja syntymävuositiedot uusille kuljettajille',
  tipAddClubAndBirthYear: '💡 Vinkki: Voit nyt lisätä seura- ja syntymävuositiedot näille kuljettajille muokkauspainikkeella (kynäkuvake).',
  noDataFoundInExcel: 'Excel-tiedostosta ei löytynyt tietoja',
  missingDriverNameOrPosition: 'Puuttuva kuljettajan nimi tai sijoitus',
  successfullyParsedResults: '✓ {count} tulos(ta) jäsennetty onnistuneesti Excel-tiedostosta',
  errorReadingExcel: 'Virhe Excel-tiedoston lukemisessa: ',
  importResults: 'Tuo {count} tulos(ta)',
  importFailed: 'Tuonti epäonnistui: ',
  new: 'UUSI',
  newDrivers: 'uusia kuljettajia',
  howToImportFromMyRCM: 'Kuinka tuoda MyRCM:stä:',
  myrcmStep1: 'Avaa kilpailutuloksesi MyRCM:ssä',
  myrcmStep2: 'Kopioi tapahtuman URL (esim. https://www.myrcm.ch/en/report/98862/393406)',
  myrcmStep3: 'Liitä se alle - järjestelmä hakee automaattisesti sekä finaalit että karsinta',
  myrcmStep4: 'Jos kilpailussa on vain karsinta, rastita "Tuo karsinta finaalina"',
  myrcmStep5: 'Klikkaa "Hae & Esikatsele"',
  myrcmStep6: 'Tarkista kuljettajavastaavuudet - korjaa virheelliset',
  myrcmStep7: 'Klikkaa "Tuo tulokset"',
  checkMatch: 'TARKISTA',
  matchedByCarNumberOnlyHint: 'Vastaavuus löytyi vain autonumeron perusteella, ei nimen - autonumerot ovat luokkakohtaisia, joten tarkista että kuljettaja on oikea',
  browseMyrcmEvents: 'Selaa tapahtumia',
  pasteUrlInstead: 'Liitä URL',
  myrcmBrowseStep1: 'Valitse tapahtuma listalta (suodata maan mukaan tai hae nimellä)',
  myrcmBrowseStep2: 'Valitse luokka',
  myrcmBrowseStep3: 'Klikkaa "Hae & Esikatsele"',
  myrcmScopeArchive: 'Menneet kilpailut',
  myrcmScopeLive: 'Käynnissä nyt',
  myrcmFilterCountry: 'Suodata maan mukaan',
  myrcmAllCountries: 'Kaikki maat',
  myrcmSearchEventsPlaceholder: 'Etsi tapahtumaa, järjestäjää tai paikkaa...',
  myrcmSearch: 'Hae',
  myrcmResults: 'Tulokset',
  myrcmPreviousPage: 'Edellinen',
  myrcmNextPage: 'Seuraava',
  myrcmLoadingEvents: 'Haetaan tapahtumia...',
  myrcmNoEventsFound: 'Tapahtumia ei löytynyt',
  myrcmFailedToLoadEvents: 'Tapahtumalistan haku epäonnistui',
  myrcmNoReportsBadge: 'ei tuloksia',
  myrcmSelectClass: 'Valitse luokka',
  myrcmLoadingClasses: 'Haetaan luokkia...',
  myrcmNoClassesForEvent: 'Tällä tapahtumalla ei ole tulosluokkia',
  myrcmFailedToLoadClasses: 'Luokkien haku epäonnistui',
  myrcmBackToEvents: 'Takaisin tapahtumiin',
  myrcmSelectedEvent: 'Valittu',
  myrcmChangeSelection: 'Vaihda',
  myrcmSiteChanged: 'MyRCM-sivun rakenne on muuttunut, eikä listaa voitu lukea',
  myrcmUsePasteInstead: 'Liitä URL sen sijaan',
  myrcmResultsUrlLabel: 'MyRCM-tulosten URL',
  urlWillBeUsedForBothFinalAndQual: 'Tätä URL:ia käytetään sekä finaali- että karsintatuloksiin',
  enterTheBaseUrlWithoutReportKey: 'Anna perus-URL (reportKey lisätään automaattisesti)',
  finalResultsUrl: 'Finaalitulosten URL',
  qualificationResultsUrl: 'Karsintatu losten URL',
  optional: '(Valinnainen)',
  fetchingFromMyRCM: 'Haetaan MyRCM:stä...',
  fetchAndPreview: 'Hae & Esikatsele tulokset',
  hideDriverMapping: 'Piilota',
  showDriverMapping: 'Näytä',
  driverMapping: 'Kuljettajien vastaavuus',
  matchDrivers: '🔗 Yhdistä kuljettajat',
  someDriversNotMatched: 'Joitakin kuljettajia ei voitu yhdistää automaattisesti. Valitse olemassa olevat kuljettajat tai luo uusia:',
  createNewDriver: '➕ Luo uusi kuljettaja (#{carNumber})',
  matchToExistingDriver: 'Yhdistä olemassa olevaan kuljettajaan',
  unmatched: 'YHDISTÄMÄTÖN',
  matched: 'YHDISTETTY',
  myrcmLabel: 'MyRCM: ',
  pleaseEnterFinalResultsUrl: 'Anna finaalitulosten URL',
  failedToFetchMyRCM: 'MyRCM-sivun haku epäonnistui',
  couldNotFindResultsTable: 'Tulosten taulukkoa ei löytynyt sivulta',
  noDriversFoundInTable: 'Tulosten taulukosta ei löytynyt kuljettajia. Tarkista selaimen konsoli.',
  successfullyFetchedFromMyRCM: '✓ {count} tulos(ta) haettu onnistuneesti MyRCM:stä',
  driversNeedManualMatching: '⚠ {count} kuljettaja(a) vaatii manuaalisen yhdistämisen tai luodaan uusina',
  pos: 'Sij.',
  qPos: 'K Sij.',
  qPts: 'K Pis.',
  pts: 'Pis.',
  importQualificationAsFinal: 'Tuo karsinta finaalituloksena',
  importQualificationAsFinalDescription: 'Käytä tätä vaihtoehtoa, kun kilpailussa on vain karsinta ilman finaalia',

  // Table headers for export
  positionShort: 'Sij.',
  nameColumn: 'Nimi',
  clubColumn: 'Seura',
  totalColumn: 'Yht.',

  // Language selector
  language: 'Kieli',
  finnish: 'Suomi',
  english: 'Englanti',
  swedish: 'Ruotsi',

  // Help System
  help: 'Ohje',
  helpPublicTitle: 'Tervetuloa RC Racing Series -järjestelmään',
  helpPublicDescription: 'Tämä järjestelmä näyttää RC-kilpailujen mestaruustulokset. Voit selata eri sarjoja, vuosia ja maita.',
  helpViewingStandings: 'Tulosten katselu',
  helpSelectCountry: 'Valitse maa valikosta yläoikealla',
  helpSelectYear: 'Valitse vuosi pudotusvalikosta',
  helpSelectSeries: 'Valitse sarja pudotusvalikosta',
  helpViewTabs: 'Selaa välilehtiä nähdäksesi mestaruustulokset, karsintatulokset ja muut kategoriat',
  helpStandingsTip: 'Tulokset päivitetään automaattisesti kilpailujen päätyttyä. Pudotetut tulokset näytetään läpinäkyvällä fontilla.',
  helpUnderstandingStandings: 'Tulosluokkien ymmärtäminen',
  helpChampionshipExplanation: 'Päätulokset kaikista kilpailuista, mahdollisilla pudotuksilla',
  helpQualificationExplanation: 'Bonuspisteet TOP 5 karsintatuloksista (5,4,3,2,1 pistettä)',
  helpJuniorExplanation: 'Erillinen mestaruus nuorille kuljettajille (määritelty ikäraja)',
  helpSeniorExplanation: 'Erillinen mestaruus vanhemmille kuljettajille (määritelty ikäraja)',
  helpRaceResults: 'Kilpailutulokset',
  helpRaceResultsDescription: 'Jokainen kilpailu näyttää sijoitukset, pisteet ja karsintasijoitukset. Voit klikata kilpailuja nähdäksesi yksityiskohtaiset tulokset.',
  helpAdminTitle: 'Hallintapaneelin opas',
  helpAdminDescription: 'Täällä voit hallita sarjoja ja niiden luokkia, kuljettajia, kilpailuja, tuloksia sekä tapahtumia ja niiden ilmoittautumisia.',
  helpManagingSeries: 'Sarjojen hallinta',
  helpSeriesDescription: 'Sarjat ovat mestaruuskausia. Jokainen sarja voi kattaa yhden tai useamman vuoden.',
  helpCreateSeries: 'Luo uusi sarja antamalla nimi, maa, aloitus- ja lopetusvuosi',
  helpConfigureSeries: 'Määritä sarjan asetukset (pudotukset, karsintapisteet, jne.)',
  helpAddDrivers: 'Lisää kuljettajat luokkaan käsin tai kopioi toisesta luokasta',
  helpAddRaces: 'Lisää kilpailut luokkaan ja tuo tulokset',
  helpSeriesSettingsTip: 'Kaikki asetusmuutokset tallennetaan automaattisesti ja tulokset päivittyvät välittömästi.',
  helpManagingDrivers: 'Kuljettajien hallinta',
  helpDriversDescription: 'Kuljettajat kuuluvat luokkaan. Lisää heidät luokkaan ennen tulosten syöttämistä.',
  helpAddDriverManually: 'Lisää kuljettaja klikkaamalla "Lisää kuljettaja" ja täyttämällä tiedot',
  helpCopyDrivers: 'Kopioi kuljettajia toisesta sarjasta säästääksesi aikaa',
  helpEditDriverInfo: 'Päivitä kuljettajatietoja (nimi, seura, syntymävuosi) kynäkuvakkeesta',
  helpDriversTip: 'Syntymävuosi tarvitaan junori- ja seniorimestaruuksia varten. Auton numero on valinnainen mutta suositeltava.',
  helpManagingRaces: 'Kilpailujen hallinta',
  helpRacesDescription: 'Kilpailu kuuluu luokkaan ja sisältää päivämäärän, nimen ja tulokset.',
  helpCreateRace: 'Luo kilpailu antamalla päivämäärä, nimi ja tunnus',
  helpAddResultsManually: 'Lisää tulokset manuaalisesti tai tuo ne',
  helpImportingResults: 'Tulosten tuonti',
  helpExcelImport: 'Tuo tulokset Excel-tiedostosta (tarvittavat sarakkeet: Driver/Name, Position/Pos, Qual/Q)',
  helpMyRCMImport: 'Tuo tulokset suoraan MyRCM-järjestelmästä URL-osoitteen avulla',
  helpRacesTip: 'Tuonnin jälkeen tarkista, että kaikki kuljettajat on yhdistetty oikein. Voit korjata virheelliset vastaavuudet ennen tuontia.',
  helpExcelFormat: 'Excel-tiedostomuoto',
  helpExcelFormatDescription: 'Excel-tiedostossasi tulee olla vähintään nämä sarakkeet:',
  helpExportingData: 'Tietojen vienti',
  helpExportDescription: 'Voit viedä mestaruustulokset Excel-tiedostoon jaettavaksi.',
  helpOpenExportDialog: 'Klikkaa "Vie Excel" valikosta',
  helpSelectExportSeries: 'Valitse vietävät sarjat (voit valita useita)',
  helpChooseExportLanguage: 'Valitse viennin kieli',
  helpDownloadExcel: 'Klikkaa "Vie" ladataksesi Excel-tiedoston',
  helpSeriesSettingsDetail: 'Sarjan asetusten yksityiskohdat',
  helpTotalRacesDetail: 'Määritä, kuinka monta kilpailua sarjassa on yhteensä.',
  helpRacesCountedDetail: 'Määritä, kuinka monta parasta tulosta lasketaan mestaruuteen. Kun kilpailuja on ajettu enemmän kuin tämä määrä, huonoimmat tulokset pudotetaan automaattisesti. Esim. 4 kilpailun sarjassa 3 laskettavaa tulosta laskee 3 parasta ja pudottaa huonoimman.',
  helpQualificationPointsDetail: 'Kun käytössä, TOP 5 karsintatulokset saavat bonuspisteitä (5,4,3,2,1). Nämä pisteet lisätään päätuloksiin.',
  helpQualificationMasterDetail: 'Luo erillisen mestaruuden pelkistä karsintapisteistä (ei pudotuksia). Näyttää kuka on paras karsija.',
  helpAgeChampionshipsDetail: 'Luo erilliset mestaruudet ikäryhmille. Määritä ikäraja (esim. 18 junioreille, 40 senioreille).',
  helpCommonFeatures: 'Yleiset ominaisuudet',
  helpLanguageDescription: 'Vaihda käyttöliittymän kieli (Suomi, Englanti, Ruotsi)',
  helpCountryDescription: 'Suodata sarjat maan mukaan nähdäksesi vain kyseisen maan kilpailut',
  helpYearDescription: 'Valitse vuosi nähdäksesi kyseisen kauden sarjat',
  helpNeedMoreHelp: 'Tarvitsetko lisäapua?',
  helpContactDescription: 'Jos sinulla on kysymyksiä tai ongelmia, ota yhteyttä järjestelmän ylläpitäjään.',
  helpVersion: 'Versio',
  helpSystemName: 'Järjestelmän nimi',
  // Help - classes, calendar, online entry, imports (added 2026-09)
  helpSelectClass: 'Valitse luokka sarjan sisältä — jokaisella luokalla on omat tuloksensa',
  helpRaceCalendar: 'Kilpailukalenteri',
  helpRaceCalendarDescription: 'Kalenteri listaa tulevat ja menneet tapahtumat. Avaa tapahtuma nähdäksesi sen tiedot, luokat ja ilmoittautuneet.',
  helpCalendarColours: 'Jokainen tapahtuma on väritetty ilmoittautumisen tilan mukaan: ilmoittautuminen auki, ei vielä auki tai suljettu.',
  helpEntering: 'Kilpailuun ilmoittautuminen',
  helpEnteringDescription: 'Kun tapahtuma ottaa ilmoittautumisia tällä sivustolla, avaa se ja paina Ilmoittaudu.',
  helpEnterPickClasses: 'Valitse luokat, joihin haluat osallistua, ja anna kullekin transponderinumero — voit jättää sen tyhjäksi ja hoitaa asian radalla.',
  helpEnterDetails: 'Täytä nimesi, seurasi, autonumerosi ja yhteystietosi.',
  helpEnterExtras: 'Vastaa järjestäjän lisäkysymyksiin — esimerkiksi lounastilaukseen tai rengasvalintaan. Osa kysymyksistä tulee näkyviin vasta, kun vastaat toiseen kysymykseen.',
  helpEnterSaveLink: 'Tallenna saamasi linkki. Sitä ei lähetetä sähköpostilla, ja se on ainoa tapa muokata tai perua ilmoittautuminen myöhemmin.',
  helpEnteringTip: 'Jos luokka on täynnä, pääset varasijalle ja järjestäjä on sinuun yhteydessä.',
  helpClasses: 'Sarjat ja luokat',
  helpClassesDescription: 'Sarja on mestaruuskausi. Sen luokat (esimerkiksi 1:8 Nitro, 1:10 sähkö) ovat se taso, jolla kuljettajat, kilpailut ja tulokset todella ovat — luo siis ensin luokka sarjan alle ja lisää kuljettajat ja kilpailut siihen luokkaan.',
  helpEvents: 'Tapahtumat ja ilmoittautuminen',
  helpEventsDescription: 'Tapahtuma on kilpailu, johon voi ilmoittautua verkossa. Järjestäjät voivat luoda ja muokata omia tapahtumiaan.',
  helpEventCreate: 'Luo tapahtuma nimineen, paikkoineen, päivineen ja luokkineen.',
  helpEventEntryWindow: 'Aseta ilmoittautumisaika — ilmoittautuminen aukeaa ja sulkeutuu valitseminasi päivinä, ja kalenteri näyttää tilan.',
  helpEventQuestions: 'Lisää lisäkysymyksiä ilmoittautujille (lounas, rengasvalinta ja niin edelleen). Kysymys voidaan asettaa näkymään vain, kun toiseen on vastattu kyllä.',
  helpEventExternalEntry: 'Jos ilmoittautuminen hoidetaan toisessa järjestelmässä, lisää sen osoite, jolloin ilmoittautumispainike ohjaa käyttäjät sinne.',
  helpEventEntrantList: 'Lataa ilmoittautuneiden lista, mukaan lukien lisäkysymysten vastaukset ja niiden yhteismäärät.',
  helpAddAllClasses: 'Käytä "Lisää kaikki sarjasta" lisätäksesi mestaruuden kaikki luokat tapahtumaan yhdellä painalluksella.',
  helpEventCopy: 'Kopioi tapahtuma käyttääksesi sen luokat ja kysymykset uudelleen — kaikki kopioidaan paitsi päivämäärät.',
  helpCopyRace: 'Kopioi kilpailu ensi vuodelle siirtääksesi sen asetukset uuteen kauteen, ja aseta sitten uudet päivämäärät.',
  helpLiveRCImport: 'Tuo tulokset suoraan LiveRC:stä tapahtuman osoitteella — jokainen tapahtuman luokka luetaan siitä.',
  // Events / calendar
  eventManagement: 'Kilpailujen hallinta',
  eventsTab: 'Kalenteri',
  addEvent: 'Lisää kilpailu',
  editEvent: 'Muokkaa kilpailua',
  deleteEvent: 'Poista kilpailu',
  eventName: 'Kilpailun nimi',
  eventOrganizer: 'Järjestäjä',
  eventVenue: 'Rata',
  eventAddress: 'Osoite',
  eventCity: 'Paikkakunta',
  eventCountry: 'Maa',
  eventChampionship: 'Arvokilpailu',
  championshipNone: 'Tavallinen kilpailu',
  championshipEuropean: 'EM-kilpailu',
  championshipWorld: 'MM-kilpailu',
  championshipHint: 'Arvokilpailu näkyy kaikkien maiden kalentereissa, ei vain omansa.',
  championshipHostedIn: 'Järjestäjämaa',
  championshipReadOnly: 'Järjestää {country}',
  eventStartDate: 'Alkamispäivä',
  eventEndDate: 'Päättymispäivä',
  eventEndDateOptional: 'Päättymispäivä (valinnainen)',
  eventDescription: 'Kuvaus',
  eventStatus: 'Tila',
  eventStatusDraft: 'Luonnos',
  eventStatusPublished: 'Julkaistu',
  eventStatusCancelled: 'Peruttu',
  eventEntryOpens: 'Ilmoittautuminen alkaa',
  eventEntryCloses: 'Ilmoittautuminen päättyy',
  eventEntryInstructions: 'Ilmoittautumisohjeet',
  eventEntryListPublic: 'Näytä ilmoittautuneet julkisesti',
  eventEntryListPublicDescription: 'Julkisessa näkymässä näytetään vain nimi, seura, kilpailunumero ja luokat.',
  eventSupportedTransponders: 'Toimivat ponderit',
  eventContactEmail: 'Yhteyssähköposti',
  eventContactPhone: 'Yhteyspuhelin',
  eventWebsite: 'Verkkosivu',
  eventOwner: 'Omistaja',
  eventClasses: 'Luokat',
  eventAddClass: 'Lisää luokka',
  eventClassName: 'Luokan nimi',
  eventClassSeries: 'Sarja',
  eventClassNoSeries: 'Ei sarjaa',
  eventClassEntryLimit: 'Osallistujaraja',
  eventClassLinkedResults: 'Tulokset linkitetty',
  eventClassRoundReady: 'Osakilpailu valmiina',
  eventClassRoundReadyHelp: 'Luokalla on osakilpailu sarjassa. Tulokset voi tuoda siihen, kun kisa on ajettu.',
  eventNoClasses: 'Ei luokkia vielä',
  // Lisäpalvelut - kysymykset, jotka järjestäjä lisää omaan ilmoittautumiseensa.
  // Järjestäjän oma kysymysteksti tallennetaan sellaisenaan eikä sitä käännetä;
  // vain sen ympärillä oleva käyttöliittymä on käännetty.
  eventExtras: 'Lisäpalvelut ja ennakkotilaukset',
  eventExtrasHelp: 'Mitä muuta haluat kysyä ilmoittautujalta: lounas, rengassetit, varikkopaikka. Vain määrät, ei hintoja.',
  eventNoExtras: 'Ei lisäkysymyksiä',
  eventAddExtra: 'Lisää kysymys',
  extraLabel: 'Mitä haluat kysyä?',
  extraHelpText: 'Ohjeteksti (valinnainen)',
  extraType: 'Vastaus',
  extraTypeYesNo: 'Kyllä / ei',
  extraTypeNumber: 'Lukumäärä',
  extraTypeText: 'Vapaa teksti',
  extraRequired: 'Pakollinen',
  extraAlwaysAsked: 'Kysytään aina',
  extraOnlyWhen: 'vain kun: {question}',
  extraDependencyLocked: 'Toinen kysymys riippuu tästä, joten tämän on pysyttävä kyllä/ei-kysymyksenä eikä se voi itse olla ehdollinen.',
  extraMinValue: 'Vähintään',
  extraMaxValue: 'Enintään',
  extraLabelRequired: 'Kirjoita kysymys ensin',
  extraLabelTooLong: 'Kysymys on liian pitkä',
  extraTypeLocked: 'Tähän on jo vastattu, joten vastaustyyppiä ei voi vaihtaa. Lisää uusi kysymys sen sijaan.',
  extraAnswered: '{count} vastannut',
  deleteExtraConfirm: 'Poistetaanko tämä kysymys?',
  deleteExtraDiscardConfirm: '{count} on vastannut tähän. Poistetaanko silti ja hylätäänkö vastaukset?',
  failedToSaveExtra: 'Kysymyksen tallennus epäonnistui',
  failedToDeleteExtra: 'Kysymyksen poisto epäonnistui',
  entryExtras: 'Lisäpalvelut',
  entryExtrasHelp: 'Järjestäjä haluaisi tietää:',
  entrantExtrasTotals: 'Tilattu yhteensä',
  // Koko sarjan luokkien lisääminen kerralla.
  eventAddAllFromSeries: 'Lisää kaikki sarjasta',
  eventAddAllFromSeriesHelp: 'Lisää valitun sarjan kaikki luokat tähän kilpailuun ja ohittaa ne, jotka siinä jo ovat.',
  eventPickSeriesFirst: 'Valitse ensin sarja',
  eventAddAllFromSeriesDone: '{created} luokkaa lisätty',
  eventAddAllFromSeriesSkipped: '{skipped} oli jo lisätty',
  eventAddAllFromSeriesNone: 'Kilpailussa on jo kaikki sarjan luokat',
  // Kilpailun kopiointi.
  eventCopy: 'Kopioi',
  eventCopyTitle: 'Kopioi kilpailu',
  eventCopySuffix: '{name} (kopio)',
  eventCopyDatesCleared: 'Kaikki kopioidaan paitsi päivämäärät. Täytä uuden kilpailun ajopäivät ja ilmoittautumisaika.',
  eventCopyCarries: '{classes} luokkaa ja {extras} lisäpalvelua kopioidaan. Voit muokata niitä tallennuksen jälkeen.',
  noEvents: 'Ei kilpailuja',
  eventNameRequired: 'Kilpailun nimi vaaditaan',
  eventStartDateRequired: 'Alkamispäivä vaaditaan',
  eventClassNameRequired: 'Luokan nimi vaaditaan',
  deleteEventConfirm: 'Poistetaanko tämä kilpailu?',
  deleteClassConfirm: 'Poistetaanko tämä luokka?',
  failedToLoadEvents: 'Kilpailujen haku epäonnistui',
  failedToSaveEvent: 'Kilpailun tallennus epäonnistui',
  failedToDeleteEvent: 'Kilpailun poisto epäonnistui',
  failedToSaveClass: 'Luokan tallennus epäonnistui',
  failedToDeleteClass: 'Luokan poisto epäonnistui',
  eventMineOnly: 'Vain omat',
  eventAllYears: 'Kaikki vuodet',
  eventBasicInfo: 'Perustiedot',
  eventLocation: 'Sijainti',
  eventEntrySettings: 'Ilmoittautuminen',
  eventExternalEntry: 'Ilmoittautuminen toisessa järjestelmässä',
  eventExternalEntryHint: 'Ilmoittautumispainike vie kilpailijan sinne. Tämä sivusto ei kerää tämän kilpailun ilmoittautumisia.',
  eventExternalEntryUrl: 'Ilmoittautumisen osoite',
  entryRegisterExternally: 'Ilmoittaudu osoitteessa',
  entryHandledElsewhere: 'Tämän kilpailun ilmoittautuminen hoidetaan tämän sivuston ulkopuolella.',
  externalEntryNeedsUrl: 'Anna osoite johon kilpailijat ohjataan.',
  // Roles
  organizer: 'Järjestäjä',
  competitor: 'Kilpailija',
  organizerRole: 'Järjestäjä:',
  organizerDescription: 'Voi luoda ja muokata omia kilpailujaan sekä ladata niiden ilmoittautuneet. Ei oikeuksia sarjoihin tai tuloksiin.',
  competitorRole: 'Kilpailija:',
  competitorDescription: 'Näkee ja muokkaa omia tietojaan sekä omia ilmoittautumisiaan.',
  // Public calendar
  calendar: 'Kilpailukalenteri',
  calendarTitle: 'Kilpailukalenteri',
  calendarBack: 'Takaisin kalenteriin',
  calendarNoEvents: 'Ei kilpailuja valituilla suodattimilla',
  calendarAllCountries: 'Kaikki maat',
  calendarLoading: 'Haetaan kilpailuja...',
  calendarFailedToLoad: 'Kilpailukalenterin haku epäonnistui',
  calendarLegacyRace: 'Sarjan osakilpailu',
  calendarEntryOpen: 'Ilmoittautuminen auki',
  calendarEntryNotYetOpen: 'Ilmoittautuminen ei ole vielä auki',
  calendarEntryClosed: 'Ilmoittautuminen suljettu',
  calendarEntrants: 'ilmoittautunutta',
  calendarEventNotFound: 'Kilpailua ei löytynyt',
  eventDetails: 'Kilpailun tiedot',
  eventEntrantList: 'Ilmoittautuneet',
  eventNoEntrants: 'Ei vielä ilmoittautuneita',
  eventEntrantListHidden: 'Järjestäjä ei julkaise ilmoittautuneiden listaa.',
  eventCarNumber: 'Kilpailunumero',
  eventClub: 'Seura',
  eventEntryLimitReached: 'Täynnä',
  eventCancelled: 'Tämä kilpailu on peruttu.',
  eventNoTransponders: 'Ei ilmoitettu',
  eventContact: 'Yhteystiedot',
  calendarMonths: 'tammi,helmi,maalis,huhti,touko,kesä,heinä,elo,syys,loka,marras,joulu',
  // Month grid
  calendarViewGrid: 'Kuukausi',
  calendarViewList: 'Lista',
  calendarPrevMonth: 'Edellinen kuukausi',
  calendarNextMonth: 'Seuraava kuukausi',
  calendarToday: 'Tänään',
  calendarWeekdays: 'ma,ti,ke,to,pe,la,su',
  calendarMonthsFull: 'tammikuu,helmikuu,maaliskuu,huhtikuu,toukokuu,kesäkuu,heinäkuu,elokuu,syyskuu,lokakuu,marraskuu,joulukuu',
  calendarMoreEvents: '+{count} lisää',
  calendarNoEventsThisMonth: 'Ei kilpailuja tässä kuussa',
  eventClassSeriesLocked: 'Sarjaa ei voi vaihtaa, koska luokkaan on jo linkitetty tulokset.',
  eventClassSaved: 'Luokka päivitetty',

  // Entries
  entryEnter: 'Ilmoittaudu',
  entryTitle: 'Ilmoittautuminen',
  entryFirstName: 'Etunimi',
  entryLastName: 'Sukunimi',
  entryTransponderNumber: 'Ponderin numero',
  entryClassTransponder: 'Ponderi',
  entryTransponderPerClassHint: 'Anna jokaiselle luokalle ponderin numero, jota käytät siinä luokassa. Voit jättää sen tyhjäksi ja täydentää kisapaikalla.',
  transponderNumberPlaceholder: 'esim. 0012345',
  entryCarNumber: 'Kilpailunumero',
  entryClub: 'Seura',
  entryBirthYear: 'Syntymävuosi',
  entryEmail: 'Sähköposti',
  entryPhone: 'Puhelinnumero',
  entryNotes: 'Lisätiedot',
  entrySelectClasses: 'Valitse luokat',
  entryOptional: 'valinnainen',
  entrySubmit: 'Lähetä ilmoittautuminen',
  entrySubmitting: 'Lähetetään...',
  entrySuccessTitle: 'Ilmoittautuminen vastaanotettu',
  entrySuccessWaitlisted: 'Luokka on täynnä, joten olet varasijalla. Järjestäjä on yhteydessä.',
  entryManageLinkTitle: 'Tallenna tämä linkki',
  entryManageLinkHelp: 'Linkillä voit muokata tai perua ilmoittautumisesi. Linkkiä ei lähetetä sähköpostilla, joten ota se talteen nyt.',
  entryCopyLink: 'Kopioi linkki',
  entryLinkCopied: 'Kopioitu',
  entryMyEntriesOnDevice: 'Tällä laitteella tehdyt ilmoittautumiset',
  entryManageTitle: 'Oma ilmoittautuminen',
  entryWithdraw: 'Peru ilmoittautuminen',
  entryWithdrawConfirm: 'Perutaanko ilmoittautuminen?',
  entryWithdrawn: 'Ilmoittautuminen on peruttu.',
  entryUpdated: 'Tiedot tallennettu.',
  entryNotFound: 'Ilmoittautumista ei löytynyt. Tarkista linkki.',
  entryClosedForChanges: 'Ilmoittautuminen on sulkeutunut. Ota yhteyttä järjestäjään.',
  entryHumanCheck: 'Vahvista, että olet ihminen',
  entryTurnstileMissing: 'Botti-suojausta ei ole määritetty, joten ilmoittautuminen ei ole käytössä.',
  entryDuplicateTransponder: 'Sama ponderinumero on jo käytössä tässä kilpailussa. Tarkista numero.',
  entryPickAtLeastOneClass: 'Valitse vähintään yksi luokka',
  entryFailed: 'Ilmoittautuminen epäonnistui',
  entryStatusRegistered: 'Ilmoittautunut',
  entryStatusWaitlisted: 'Varasijalla',
  entryStatusCancelled: 'Peruttu',

  // Signup during entry
  entryCreateAccount: 'Luo samalla tunnus',
  entryCreateAccountHelp: 'Tunnuksella pääset muokkaamaan ilmoittautumisiasi myöhemmin ilman erillistä linkkiä, ja tietosi täyttyvät valmiiksi seuraavalla kerralla.',
  entryPassword: 'Salasana',
  entryPasswordHint: 'Vähintään 8 merkkiä',
  entryAccountCreated: 'Tunnus luotu ja olet nyt kirjautunut sisään.',
  entryPasswordTooShort: 'Salasanan on oltava vähintään 8 merkkiä',
  entrySignedInAs: 'Kirjautuneena',

  // Entrant list
  entrantList: 'Ilmoittautuneet',
  entrantListOpen: 'Näytä ilmoittautuneet',
  entrantCount: 'ilmoittautunutta',
  entrantNone: 'Ei vielä ilmoittautuneita',
  entrantExport: 'Lataa ajanottoa varten',
  entrantExportFormat: 'Ajanottojärjestelmä',
  entrantExportExcel: 'Lataa Excel',
  entrantExportCsv: 'Lataa CSV',
  entrantFilterAll: 'Kaikki',
  entrantTransponder: 'Ponderi',
  entrantContact: 'Yhteystiedot',
  entrantStatus: 'Tila',
  entrantFailedToLoad: 'Ilmoittautuneiden haku epäonnistui',
  entrantExportFailed: 'Lataus epäonnistui',
  entrantNoTransponder: 'ei ponderia',
  entrantRemove: 'Poista ilmoittautuminen',
  entrantRemoveConfirm: 'Poistetaanko tämä ilmoittautuminen pysyvästi?',

  // Competitor account
  myTransponders: 'Omat ponderit',
  myTranspondersHint: 'Lista täydentyy itsestään, kun ilmoittaudut kisoihin: uusi numero tallentuu tähän ja on seuraavalla kerralla valmiina valittavaksi.',
  transponderAdd: 'Lisää',
  transponderLabelField: 'Nimi (valinnainen)',
  transponderRemove: 'Poista listalta',
  transponderNoneSaved: 'Et ole vielä tallentanut yhtään ponderia.',
  accountTitle: 'Omat tiedot',
  accountProfile: 'Perustiedot',
  accountMyEntries: 'Omat ilmoittautumiset',
  accountNoEntries: 'Et ole vielä ilmoittautunut yhteenkään kilpailuun',
  accountSaved: 'Tiedot tallennettu',
  accountSaveFailed: 'Tietojen tallennus epäonnistui',
  accountLoadFailed: 'Tietojen haku epäonnistui',
  accountPrefillHelp: 'Nämä tiedot täytetään valmiiksi, kun ilmoittaudut kilpailuun.',
  accountBrowseCalendar: 'Selaa kilpailukalenteria',
  accountEntryClosed: 'Ilmoittautuminen sulkeutunut',
  accountManageEntry: 'Muokkaa',
  accountUsername: 'Käyttäjänimi',

  // Linking results to a series
  linkResults: 'Ota tulokset käyttöön',
  linkResultsHelp: 'Luo sarjaan osakilpailun, johon tämän luokan tulokset tallennetaan. Tee tämä vasta kun olet valmis kirjaamaan tuloksia.',
  linkResultsDone: 'Tulokset linkitetty sarjaan',
  linkResultsNoSeries: 'Liitä luokka ensin sarjaan',
  syncDrivers: 'Siirrä ilmoittautuneet kuljettajiksi',
  syncDriversHelp: 'Luo sarjaan kuljettajat ilmoittautuneista, jotta tulokset voidaan kirjata heille.',
  syncDriversResult: '{created} luotu, {matched} tunnistettu, {already} jo linkitetty',
  syncDriversConflicts: 'Ristiriidat',
  syncDriversConflictNumber: 'kilpailunumero on jo toisen kuljettajan käytössä tässä sarjassa',
  linkFailed: 'Toiminto epäonnistui',
  entryLoginIsEmail: 'Kirjautumistunnus (sähköposti)',
  entryLoginIsEmailHint: 'Kirjaudut sisään tällä sähköpostiosoitteella. Erillistä käyttäjänimeä ei tarvita.',
  entryEmailRequiredForAccount: 'Sähköpostiosoite tarvitaan tunnuksen luomiseen',
  entryEmailTaken: 'Tälle sähköpostiosoitteelle on jo tunnus',

  // Password reset
  forgotPassword: 'Unohtuiko salasana?',
  forgotPasswordTitle: 'Uusi salasana',
  forgotPasswordHelp: 'Anna sähköpostiosoitteesi, niin lähetämme linkin uuden salasanan asettamiseen.',
  forgotPasswordSend: 'Lähetä linkki',
  forgotPasswordSent: 'Jos osoitteella on tunnus, linkki on matkalla. Tarkista myös roskapostikansio.',
  forgotPasswordCompetitorsOnly: 'Tämä koskee vain kilpailijoiden tunnuksia. Ylläpito nollaa henkilökunnan salasanat.',
  resetPasswordTitle: 'Aseta uusi salasana',
  resetPasswordNew: 'Uusi salasana',
  resetPasswordConfirm: 'Vahvista salasana',
  resetPasswordSubmit: 'Tallenna salasana',
  resetPasswordDone: 'Salasana vaihdettu. Voit nyt kirjautua sisään.',
  resetPasswordExpired: 'Linkki ei ole enää voimassa. Pyydä uusi.',
  resetPasswordMismatch: 'Salasanat eivät täsmää',
  resetPasswordChecking: 'Tarkistetaan linkkiä...',
  backToLogin: 'Kirjautumiseen',
};

export default fi;
